import * as React from "react";
import { connect } from "react-redux";
import ProductReturns from "../../screens/ProductReturns";

import {
  ProductReturn,
  ProductReturnsSlectedPage,
  ProductReturnsSearch,
  ProductReturnsSearchSelectedPage,
  ProductReturnview,
  FliterSearchProductUser,
  fltrProductUserPagetn
} from "./action";
class ProductReturnsContainer extends React.Component<Props, State> {
  render() {
    return (
      <ProductReturns
        ProductReturn={this.props.ProductReturn}
        ProductReturnDtlsList={this.props.ProductReturnDtlsList}
        ProductReturnlsCount={this.props.ProductReturnlsCount}
        ProductReturnsSlectedPage={this.props.ProductReturnsSlectedPage}
        ProductReturnsSearch={this.props.ProductReturnsSearch}
        ProductReturnsSearchSelectedPage={
          this.props.ProductReturnsSearchSelectedPage
        }
        ProductReturnSearchList={this.props.ProductReturnSearchList}
        ProductReturnSearchCount={this.props.ProductReturnSearchCount}
        ProductReturnview={this.props.ProductReturnview}
        ProductReturnls={this.props.ProductReturnls}
        ProductReturnDtlsCount={this.props.ProductReturnDtlsCount}
        FliterSearchProductUser={this.props.FliterSearchProductUser}
        fltrProductUserPagetn={this.props.fltrProductUserPagetn}
        productuserFilterList={this.props.productuserFilterList}
        productuserFilterCount={this.props.productuserFilterCount}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    ProductReturn: () => {
      dispatch(ProductReturn());
    },
    ProductReturnsSlectedPage: value => {
      dispatch(ProductReturnsSlectedPage(value));
    },
    ProductReturnsSearch: value => {
      dispatch(ProductReturnsSearch(value));
    },
    ProductReturnsSearchSelectedPage: value => {
      dispatch(ProductReturnsSearchSelectedPage(value));
    },
    ProductReturnview: value => {
      dispatch(ProductReturnview(value));
    },
    FliterSearchProductUser: value => {
      dispatch(FliterSearchProductUser(value));
    },
    fltrProductUserPagetn: value => {
      dispatch(fltrProductUserPagetn(value));
    }
  };
}
const mapStateToProps = state => {
  return {
    ProductReturnDtlsList: state.ProductReturnsReducer.ProductReturnDtlsList,
    ProductReturnlsCount: state.ProductReturnsReducer.ProductReturnlsCount,
    ProductReturnSearchList:
      state.ProductReturnsReducer.ProductReturnSearchList,
    ProductReturnSearchCount:
      state.ProductReturnsReducer.ProductReturnSearchCount,
    ProductReturnDtlsCount: state.ProductReturnsReducer.ProductReturnDtlsCount,
    ProductReturnls: state.ProductReturnsReducer.ProductReturnls,
    productuserFilterList: state.ProductReturnsReducer.productuserFilterList,
    productuserFilterCount: state.ProductReturnsReducer.productuserFilterCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(ProductReturnsContainer);
